import { Link } from 'react-router';

import { Button } from '@mds/shared/ui/shadcn/button';

/** Fallback for an admin route that does not exist. */
export default function NotFoundPage() {
  return (
    <div className="flex flex-col items-start py-16">
      <p className="font-mono text-sm text-muted-foreground">404</p>
      <h1 className="mt-2 text-2xl font-semibold tracking-tight">Page not found</h1>
      <p className="mt-2 text-sm text-muted-foreground">That admin route does not exist yet.</p>
      <Button className="mt-6" asChild>
        <Link to="/">Back to dashboard</Link>
      </Button>
    </div>
  );
}
